import { useAuth, useMarketplace, useMasterData, useTimeZone } from 'hooks';
import { BlockCalendarWebSocketsMessage } from 'model/WebSockets';
import { FunctionComponent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { handleBlockCalendarsWebSocketMessage } from './handlers/blockCalendarsMessageHandler';
import { useActionCableChannel } from './useActionCableChannel';

const BlockCalendarsWebSockets: FunctionComponent = () => {
    const auth = useAuth();
    const timeZone = useTimeZone();
    const masterData = useMasterData();
    const marketplace = useMarketplace();
    const dispatch = useDispatch();

    const calendarId = marketplace.schedule?.id;

    const onReceived = useCallback(
        (message: BlockCalendarWebSocketsMessage) => {
            handleBlockCalendarsWebSocketMessage(message, dispatch, timeZone, masterData);
        },
        [dispatch, masterData, timeZone]
    );

    useActionCableChannel<BlockCalendarWebSocketsMessage>({
        channel: 'BlockCalendarsChannel',
        params: {
            marketplace_id: auth.marketplaceId,
            calendar_id: calendarId
        },
        enabled: Boolean(auth.signedIn && auth.marketplaceId && calendarId),
        onReceived,
        subscriptionDeps: [auth.marketplaceId, calendarId],
        logLabel: 'BlockCalendarsWebSockets'
    });

    return null;
};

export default BlockCalendarsWebSockets;
